// 파일 → base64 data URL 변환 — 앰버서더 계약 파일(통장사본/사업자등록증) 업로드용.
// 서버는 파일을 base64 data URL 문자열(JSON 필드)로 받아 DB 에 저장한다 (별도 오브젝트 스토리지 없음).

// 서버 캡(base64 data URL 7,000,000자)과 페어인 업로드 상한 — 바이너리 기준 5MB.
export const CONTRACT_FILE_MAX_BYTES = 5 * 1024 * 1024;

export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
